import range from 'lodash/range';
import flatMap from 'lodash/flatMap';

import { DEFAULT_LIMIT } from '../common/constants';

const fetchAllItems = async (resolver, limit = DEFAULT_LIMIT) => {
    const firstItemsResult = await resolver({ limit, offset: 0 });
    
    if (!firstItemsResult?._metadata) {
        throw new Error('API response missing _metadata field. Pagination is not supported.');
    }
    
    const total = firstItemsResult._metadata.total;
    const firstItemsLimit = firstItemsResult._metadata.limit;
    
    if (typeof total !== 'number' || typeof firstItemsLimit !== 'number') {
        throw new Error('API response missing required pagination fields (total or limit). Pagination is not supported.');
    }

    let restItems = [];

    if (total > limit) {
        const rangeEnd = Math.ceil(total / firstItemsLimit);

        restItems = range(1, rangeEnd).map(index => resolver({ limit, offset: limit * index }));
    }

    return [
        ...firstItemsResult?.items || [],
        ...flatMap(
            await Promise.all(restItems),
            itemsResult => itemsResult?.items || [],
        ),
    ];
};

export default fetchAllItems;
